import { cacheUserInfo, login } from "features/authSlice";
import store from "../cache/store";
import { UserInfoModel } from "models/userInfoModel";
import toast from "react-hot-toast";
import { openLoadingFull } from "features/msgSystemSlice";

function HandlerError(data: any, cb: (action: string, msgError: string) => void, nameApi: string, isDismissLoading = true) {
    // console.log(`=========>${nameApi}`, data);

    let msg = data['msg'] || data['message'];
    
    if (isDismissLoading || (msg && msg !== '')) {
        store.dispatch(openLoadingFull(false));
    }

    // update app
    if (msg && msg === '-2') {
        toast.error('-2');
    }
    // update infor user for login firt time
    else if (msg && msg === '-1') {
        cb('update', msg);
    } else if (msg && msg === '查无记录') {
        toast.error('Không tìm thấy dữ liệu!');
    } else if (msg && msg !== '') {
        const cloneMsg = msg.trim().toLowerCase();
        if (cloneMsg.search('lỗi thông số') >= 0) {
            localStorage.removeItem('token');
            store.dispatch(cacheUserInfo({} as UserInfoModel));
            store.dispatch(login(false));
            if (nameApi === 'getUserInfo') {
                console.log(`${nameApi}: ${msg}`);
            }
        } else if (nameApi === 'WithdrawalBean' && cloneMsg.search('chưa liên kết thẻ ngân hàng') >= 0) {
            cb('warning', msg);
        } else if (cloneMsg.search('vui lòng đăng nhập lại') >= 0) {
            localStorage.removeItem('token');
            store.dispatch(cacheUserInfo({} as UserInfoModel));
            store.dispatch(login(false));
            toast.error(msg);
            window.location.href = '/';
        } else if (cloneMsg.search('hệ thống đang bảo trì') >= 0 || cloneMsg.search('vui lòng liên hệ cskh') >= 0) {
            cb('maintain', msg);
        } else if (cloneMsg.search('hiện đang là trang cuối') >= 0) {
            cb('warning', msg);
        } else if (cloneMsg.search("thử lại sau 20 giây!") >= 0) {
            cb('warning', msg);
        } else {
            toast.error(msg);
            cb('failed', msg);
        }
    } else {
        cb('success', '',);
    }
}

export default HandlerError;